import { useEffect, useState } from 'react';
import { KEY_LOCALSTORAGE } from '../../../../../auth/core/_consts';
import { localStorageItem } from '../../../../../utils/LocalStorage';
import { getDepartmentConfig } from '../../../../../utils/ServicesUtils';
import { CODE, RESPONSE_MESSAGE } from '../../../../../utils/Constant';
import { uniqueArrayObject } from '../../../../../utils/AppFunction';
import { toast } from 'react-toastify';

type Props = {
	defaultOptions?: any[];
	configType: number;
};

const useDepartmentOptions = ({ defaultOptions = [], configType }: Props) => {
	const currentUserDepartment = localStorageItem
		.get(KEY_LOCALSTORAGE.ACCESS_TOKEN_DECODE)
		?.['dpcodes']?.split(/\W/)?.[0];

	const [departmentOptions, setDepartmentOptions] = useState<any[]>([]);

	useEffect(() => {
		getDepartment(currentUserDepartment);
	}, []);

	const getDepartment = async (userDepartmentCode: string) => {
		try {
			const { data, code } = await getDepartmentConfig({
				requestDeptCode: userDepartmentCode,
			});

			if (CODE.SUCCESS === code) {
				const listTemp = data
					.filter((item: any) => configType === item.type)
					.map((item: any) => ({
						name: item.deptFulfillDeptName,
						value: item.deptFulfillDeptCode,
					}))
					.concat(defaultOptions);
				setDepartmentOptions(uniqueArrayObject(listTemp, 'value'));
			}
		} catch (error) {
			console.error(error);
			toast.error(RESPONSE_MESSAGE.ERROR);
		}
	};

	return {
		departmentOptions,
	};
};

export default useDepartmentOptions;
